/*
 * Array2D.ts
 */
export class Array2D {
    constructor(rows, columns) {
        this.rows = rows;
        this.columns = columns;
        this.array = [];
        for (let i = 0; i < rows; i++) {
            this.array[i] = new Array(columns);
        }
    }
    setValue(row, column, value) {
        this.array[row][column] = value;
    }
    getValue(row, column) {
        return this.array[row][column];
    }
    getRows() {
        return this.rows;
    }
    getColumns() {
        return this.columns;
    }
}
//# sourceMappingURL=Array2D.js.map